<div class="mt-50">
  <ecp-frame-details [user]="user$ | async"></ecp-frame-details>
</div>


